export default {
	data() {
		return {
			filterPayMethod: { field: "pay_method", index: null }
		};
	},
	watch: {
		"filterPayMethod.index": {
			handler(newVal) {
				let val = this.filterPayMethod;
				if (val.index != null && val.index !== "") {
					this.$set(this.kvFilter, val.field, { k: val.field, t: "int", v: val.index });
				} else {
					this.$delete(this.kvFilter, val.field);
				}
			},
			immediate: true
		}
	}
};
